/**
 * GridEventRow — `grid.event` renderer. Paints an event indicator
 * inside the parent grid's day cell.
 *
 * Typed event access goes through `EVENTS_FACADE` on the parent
 * dataSource — this class only owns visual attributes.
 */
import type { Option } from "../../core/option.ts";
import { Json } from "../../core/json.ts";
import { RendererRow } from "./renderer-row.ts";

/** The `grid.event` renderer row: paints an event marker in its parent grid's day cell. */
export class GridEventRow extends RendererRow {
  get color(): Option<string> {
    return Json.string(this.attrs(), "color");
  }
}
